<template>
    <div>
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="formSimularPlanPago" @submit.prevent="simular" class="custom-content-padding">
                <v-card flat>
                    <v-card-title v-if="$vuetify.breakpoint.smAndDown"
                        class="px-5 font-weight-bold text-body-1 primary--text justify-center py-0">
                        SIMULÁ TU PLAN DE PAGO
                    </v-card-title>
                    <div class="d-flex justify-center pa-5">
                        <v-card class="d-flex justify-center rounded-xl pa-5 ma-1" outlined color="grey lighten-3">
                            <v-row class="pa-0 ma-0">
                                <v-col cols="12" class="py-0">
                                    <div class="d-flex justify-space-between align-center">
                                        <span class="font-weight-regular text-subtitle-2">MONTO A FINANCIAR:</span>
                                        <span class="font-weight-bold text-subtitle-1 grey--text text--darken-2">
                                            {{ formatMoney(deudaPlanPagoTotales.totalPesos) }}
                                        </span>
                                    </div>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <div class="d-flex justify-space-between align-center">
                                        <span class="font-weight-regular text-subtitle-2">EN MÓDULOS:</span>
                                        <span class="font-weight-bold text-subtitle-1 grey--text text--darken-2">
                                            {{ formatFloat(deudaPlanPagoTotales.totalModulos) }}
                                        </span>
                                    </div>
                                    <v-divider></v-divider>
                                </v-col>
                                <v-col cols="12" class="py-0">
                                    <div class="d-flex primary--text justify-space-between align-center">
                                        <span class="font-weight-bold text-subtitle-2">VALOR ACTUAL DEL
                                            MÓDULO:</span>
                                        <span class="font-weight-bold text-subtitle-1 primary--text">
                                            {{ formatMoney(deudaPlanPagoTotales.valmod) }}
                                        </span>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card>
                    </div>
                    <div class="px-5" v-if="!simula">
                        <v-card flat class="pa-2">
                            <!--                             <div class=" font-weight-bold text-body-2 primary--text  pb-2"
                                :class="$vuetify.breakpoint.xsOnly ? 'd-flex justify-start' : 'd-flex justify-center'">
                                TIPO DE FINANCIACIÓN
                            </div> -->
                            <v-row class="px-2 ma-0">
                                <v-col cols="12" md="12" class=" justify-center align-center px-5">
                                    <v-select :items="buttons" item-text="text" item-value="value"
                                        label="Seleccioná un tipo de plan" v-model="tipoPP" outlined
                                        @change="(val) => { selectButton(val); onChangeTipoPlanPago(); }">
                                        <template v-slot:selection="{ item }">
                                            <span class="primary--text font-weight-bold">{{ item.text }}</span>
                                        </template>

                                        <template v-slot:item="{ item, on, attrs }">
                                            <v-list-item v-bind="attrs" v-on="on">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="item.value === tipoPP ? 'primary--text font-weight-bold' : ''">
                                                        {{ item.text }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col v-if="selectedPlan" cols="12" md="12" class="py-0">
                                    <div v-for="(item, index) in selectedPlan.items_desc" :key="index"
                                        class="font-weight-regular text-body-2 justify-start">
                                        <v-icon color="primary" class="mr-2">mdi-circle-small</v-icon>
                                        <span>{{ item }}</span>
                                    </div>
                                    <!--     <div v-else
                                        class="d-flex align-center font-weight-regular grey--text text--darken-1">
                                        <v-icon color="grey" class="mr-2">mdi-information-outline</v-icon>
                                        <span>Seleccioná un plan para ver sus características.</span>
                                    </div> -->
                                </v-col>
                                <v-col cols="12" md="12" v-if="selectedPlan"
                                    class="d-flex flex-column justify-center mt-5 px-10">
                                    <ValidationProvider
                                        :rules="{ max_value_plan: (tipoPP == 10) ? cantMaxCuotasPesos : cantMaxCuotasModulos, min_value: 2, required_plan: (tipoPP == 10) ? cantMaxCuotasPesos : cantMaxCuotasModulos }"
                                        v-slot="{ errors }">
                                        <v-text-field dense type="number" v-model="simularPP.cancuotas"
                                            hide-spin-buttons :error-messages="errors" :label="`Cantidad de cuotas`"
                                            @keydown.up.prevent="cambiarCuotas(1)"
                                            @keydown.down.prevent="cambiarCuotas(-1)">
                                            <template v-slot:prepend>
                                                <v-btn fab x-small color="primary" class="elevation-0"
                                                    @mousedown="startDecrement" @mouseup="stopDecrement"
                                                    @mouseleave="stopDecrement" @touchstart="startDecrement"
                                                    @touchend="stopDecrement" :disabled="simularPP.cancuotas <= 2">
                                                    <v-icon>mdi-minus</v-icon>
                                                </v-btn>
                                            </template>
                                            <template v-slot:append-outer>
                                                <v-btn fab x-small color="primary" @mousedown="startIncrement"
                                                    @mouseup="stopIncrement" @touchstart="startIncrement"
                                                    @mouseleave="stopIncrement" @touchend="stopIncrement"
                                                    class="elevation-0" :disabled="simularPP.cancuotas >= maxCuotas()">
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" class="d-flex justify-center" v-if="selectedPlan">
                                    <v-btn class="pa-5 elevation-0" :disabled="invalid" block type="submit"
                                        color="primary">
                                        <v-icon class="mr-2">mdi-calculator</v-icon>Simular
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <!--
                            <v-col cols="12" md="12"
                            :class="$vuetify.breakpoint.smAndDown ? 'd-flex text-center justify-center' : 'text-center'">
                                    <div
                                        :class="$vuetify.breakpoint.mdAndUp ? 'd-flex flex-column w-100 align-center' : 'd-flex'">
                                        <v-btn v-for="button in buttons" :key="button.value" :value="button.value"
                                            :outlined="selectedBtn !== button.value" elevation="0" color="primary"
                                            class="py-5 white--text font-weight-bold" style="border: 2px solid #00A0DF;"
                                            :class="$vuetify.breakpoint.mdAndUp ? 'mb-2 w-100' : 'mr-2'"
                                            :width="$vuetify.breakpoint.mdAndUp ? '160px' : '150px'"
                                            @click="selectButton(button.value)" @change="onChangeTipoPlanPago">
                                            {{ button.text }}
                                        </v-btn>
                                    </div>
                                </v-col>
                            -->
                        </v-card>

                    </div>
                    <v-row v-else class="px-10 py-5 justify-center">
                        <v-col cols="12" md="12"
                            :class="$vuetify.breakpoint.xsOnly ? '' : 'd-flex flex-column justify-center px-12'">
                            <v-card flat class="rounded-0" v-if="cuotaUno" outlined>
                                <v-card-title class="font-weight-bold text-body-1 primary--text justify-start pa-3">
                                    Plan de pagos en {{ (tipoPP == 10) ? 'Pesos' : 'Módulos' }}
                                </v-card-title>
                                <div class="d-flex justify-center">
                                    <v-row class="pa-0 ma-0">
                                        <v-col cols="12" class="py-2">
                                            <div class="d-flex justify-space-between align-center">
                                                <span class="font-weight-regular text-subtitle-1">MONTO CUOTA
                                                    1:</span>
                                                <span
                                                    class="font-weight-bold text-subtitle-1 grey--text text--darken-2">
                                                    {{ cuotaInicial }} {{ (tipoPP == 10) ? '' : 'MÓDULOS' }}
                                                </span>
                                            </div>
                                            <v-card-text
                                                class="pa-0 font-weight-regular grey--text darken-1 text-subtitle-2">
                                                * Incluye doce (12) módulos de gastos administrativos.
                                            </v-card-text>
                                            <v-divider></v-divider>
                                        </v-col>
                                        <v-col cols="12" class="py-2">
                                            <div class="d-flex justify-space-between align-center">
                                                <span class="font-weight-regular text-subtitle-1">MONTO CUOTAS 2 A
                                                    {{
                                                        simularPP.cancuotas }}</span>
                                                <span
                                                    class="font-weight-bold text-subtitle-1 grey--text text--darken-2">
                                                    {{ cuotasPosteriores }} {{ (tipoPP == 10) ? '' : 'MÓDULOS' }}
                                                </span>
                                            </div>
                                            <v-divider></v-divider>
                                        </v-col>

                                        <v-col cols="12" class="py-2">
                                            <div class="d-flex primary--text justify-space-between align-center">
                                                <span class="font-weight-bold text-subtitle-1">MONTO TOTAL A
                                                    FINANCIAR:</span>
                                                <span class="font-weight-bold text-subtitle-1 primary--text">
                                                    {{ calculaMontoTotal }} {{ (tipoPP == 10) ? '' : 'MÓDULOS' }}
                                                </span>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </div>
                                <!-- 
                                <v-card-text class="d-flex flex-column justify-center align-center">
                                    <div class="font-weight-regular text-body-2 black--text d-flex align-center">
                                        <v-card flat
                                            class="d-inline align-center font-weight-bold justify-center rounded-0">
                                            MONTO CUOTA 1:
                                        </v-card>
                                        <v-card-text
                                            class="d-flex justify-center font-weight-regular gray--text text--darken-2 text-subtitle-2 rounded-0 px-0 py-1"
                                            flat>
                                            * Incluye doce (12) módulos de gastos administrativos.
                                        </v-card-text>
                                        <v-card dark
                                            class="d-flex align-center pa-2 font-weight-bold black--text rounded-0 justify-center"
                                            width="160px" flat
                                            style="border:4px solid #092e6f; background-color: white;">
                                            {{ cuotaInicial }} {{ (tipoPP == 10) ? '' : 'MÓDULOS' }}
                                        </v-card>
                                    </div>
                                    <div class="font-weight-bold text-body-2 black--text d-flex align-center mt-1">
                                        <v-card flat class="d-inline pa-3 rounded-0 white--text" color="secondary"
                                            width="150px">
                                            CUOTA 2 A {{ simularPP.cancuotas }}
                                        </v-card>
                                        <v-card dark flat
                                            class="d-flex align-center font-weight-bold black--text justify-center pa-2 rounded-0"
                                            style="border:4px solid #092e6f; ; background-color: white;" width="160px">
                                            {{ cuotasPosteriores }} {{ (tipoPP == 10) ? '' : 'MÓDULOS' }}
                                        </v-card>
                                    </div>
                                    <v-card-text
                                        class="d-flex justify-center font-weight-regular gray--text text--darken-2 text-subtitle-2 rounded-0 px-0 py-1"
                                        flat>
                                        * Incluye doce (12) módulos de gastos administrativos.
                                    </v-card-text>
                                    <div class="font-weight-bold text-body-1  d-flex align-center pt-2 ">
                                        <v-card flat class="d-inline rounded-0 primary--text">
                                            MONTO TOTAL FINANCIADO
                                        </v-card>
                                        <v-card flat
                                            class="d-inline align-center font-weight-bold black--text justify-center pa-2 rounded-0">
                                            {{ calculaMontoTotal }}
                                        </v-card>
                                    </div>
                                </v-card-text>
                                <v-card-text class="d-flex justify-center ma-0 pt-0">
                                    <v-btn class="pa-5 elevation-0" color="primary" @click="reestablecerSimulacion">
                                        <v-icon class="mr-2">mdi-refresh</v-icon>volver a simular
                                    </v-btn>
                                </v-card-text>
                                -->
                            </v-card>
                            <v-skeleton-loader v-else type="card" class="rounded-0" :width="'100%'" :height="'180px'" />
                        </v-col>
                    </v-row>
                </v-card>
                <v-row v-if="cuotaUno" class="px-10 pb-3">
                    <v-col cols="12" md="12" class="d-flex flex-row justify-end py-0"
                        :class="$vuetify.breakpoint.smAndDown ? 'justify-center' : 'justify-end'">
                        <ValidationProvider :rules="{ required: { allowFalse: false } }" v-slot="v">
                            <v-checkbox right :error-messages="v.errors" v-model="aceptoPP">
                                <template v-slot:label>
                                    <div :class="aceptoPP ? 'primary--text' : ''">
                                        Confirmo la presente financiación en
                                        <span class="font-weight-bold">{{ (tipoPP == 10) ? 'pesos' : 'módulos' }}</span>
                                    </div>
                                </template>
                            </v-checkbox>
                        </ValidationProvider>
                    </v-col>
                </v-row>
                <v-card-actions class="d-flex align-center custom-card-actions-ha">
                    <v-btn v-if="simula" class="pa-5 elevation-0" color="primary" @click="reestablecerSimulacion">
                        <v-icon class="mr-2">mdi-refresh</v-icon>volver a simular
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="pa-5 elevation-0" color="primary" @click="siguientePaso"
                        :disabled="!cuotaUno && !cuotasFrances || invalid">
                        <v-icon class="mr-2">mdi-chevron-right</v-icon>SIGUIENTE
                    </v-btn>
                </v-card-actions>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'FormSimularPlanPago',
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            tipoPP: '',
            selectedBtn: null,
            simula: false,
            aceptoPP: false,
            simularPP: {
                tipoPago: '',
                mpr_tipinteres: '',
                cancuotas: '',
                totamorti: '',
                totalff: '',
                totalsf: '',
                valmod: '',
                totalAportes: 0,
                numero_calculo: '',
            },
            incrementInterval: null,
            decrementInterval: null,
            porDefault: "Seleccione un tipo de plan para conocer su caracteristicas acá."
        };
    },
    methods: {
        ...mapActions('mediosDePago', ['calcularCuotasPlanPago', 'blanquearSimulacionPlanPago', 'obtenerMediosPago', 'nuevoPlanDePago', 'guardarActivos']),
        convertirNumeroATexto(num) {
            const numeros = {
                36: 'treinta y seis',
                72: 'setenta y dos',
                24: 'veinticuatro',
                48: 'cuarenta y ocho',
                60: 'sesenta',
                12: 'doce'
            };
            return numeros[num] || num.toString();
        },
        simular() {
            this.simula = true;
            this.$refs.obs.validate().then(valid => {
                if (valid) {
                    this.calcularCuotasPlanPago(this.simularPP).then(() => {

                    });
                }
            })
        },
        selectButton(value) {
            this.selectedBtn = value;
            this.tipoPP = value;
            // Forzar revalidación del formulario
            this.$nextTick(() => {
                if (this.$refs.obs) {
                    this.$refs.obs.validate();
                }
            });
        },


        siguientePaso() {
            this.$refs.obs.validate().then(valid => {
                if (valid) {
                    //this.nuevoPlanDePago(this.simularPP);
                    //this.guardarActivos(this.pp_aux);
                    this.obtenerMediosPago();
                    this.$emit('siguiente')
                }
            });
        },

        reestablecerSimulacion() {
            this.blanquearSimulacionPlanPago('');
            this.simularPP = {
                tipoPago: '',
                mpr_tipinteres: '',
                cancuotas: '',
                totamorti: '',
                totalff: '',
                totalsf: '',
                valmod: '',
                totalAportes: 0,
                totalAportesModulos: '',
                numero_calculo: '',
            };
            this.tipoPP = '';
            this.aceptoPP = false;
            this.selectedBtn = null;
            this.simula = false;
        },
        onChangeTipoPlanPago() {
            this.simularPP.tipoPago = this.tipoPP;
            this.simularPP.cancuotas = ''; // Reiniciar cantidad de cuotas al cambiar el tipo de plan
        },
        cambiarCuotas(delta) {
            let min = 2;
            let max = (this.tipoPP == 10) ? this.cantMaxCuotasPesos : this.cantMaxCuotasModulos;
            let val = parseInt(this.simularPP.cancuotas) || 0;
            val += delta;
            if (val < min) val = min;
            if (val > max) val = max;
            this.simularPP.cancuotas = val;
        },
        maxCuotas() {
            return (this.tipoPP == 10) ? this.cantMaxCuotasPesos : this.cantMaxCuotasModulos;
        },
        formatMoney(value) {
            return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
        },
        formatFloat(value) {
            return value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        startIncrement() {
            this.cambiarCuotas(1);
            if (this.incrementInterval) return;
            this.incrementInterval = setInterval(() => {
                this.cambiarCuotas(1);
            }, 100);
        },
        stopIncrement() {
            if (this.incrementInterval) {
                clearInterval(this.incrementInterval);
                this.incrementInterval = null;
            }
        },
        startDecrement() {
            this.cambiarCuotas(-1);
            if (this.decrementInterval) return;
            this.decrementInterval = setInterval(() => {
                this.cambiarCuotas(-1);
            }, 100);
        },
        stopDecrement() {
            if (this.decrementInterval) {
                clearInterval(this.decrementInterval);
                this.decrementInterval = null;
            }
        },
    },
    computed: {
        ...mapGetters('mediosDePago', ['parametrosPlanPago', 'deudaPlanPagoTotales', 'cuotaUno', 'cuotasFrances', 'pp_aux', 'cantMaxCuotasModulos', 'cantMaxCuotasPesos', 'maxCuotasPesosTexto', 'maxCuotasModulosTexto']),
        ...mapGetters('auth', ['nroafi']),
        ...mapGetters(['emailAfi']),
        buttons() {
            return [
                {
                    text: 'Plan de pagos en Pesos',
                    value: 10,
                    items_desc: [
                        'Tasa de interés del 30% para operaciones que superen las 3 cuotas;',
                        `La cantidad máxima de cuotas permitidas es de ${this.maxCuotasPesosTexto};`,
                        'Gastos administrativos: 12 módulos (incluidos en la primera cuota);'
                    ],
                    descripcion_corta: `El plan de pagos en pesos contempla una tasa de interés del 30% para operaciones que superen las tres (3) cuotas. La cantidad máxima de cuotas permitidas es de ${this.convertirNumeroATexto(this.maxCuotasPesosTexto)} (${this.maxCuotasPesosTexto}), siempre que el monto de la cuota mínima sea superior al valor equivalente de diez (10) módulos.`
                },
                {
                    text: 'Plan de pagos en Módulos',
                    value: 20,
                    items_desc: [
                        // Se comentó el dia 11/09/2026 por resolución de directorio será valido por un año
                        //'Tasa de interés del 6% para operaciones que superen las 3 cuotas;',
                        `La cantidad máxima de cuotas permitidas es de ${this.maxCuotasModulosTexto}`,
                        'Gastos administrativos: 12 módulos (incluidos en la primera cuota);'
                    ],
                    descripcion_corta: `El plan de pagos en módulos contempla una tasa de interés del 6% para operaciones que superen las tres (3) cuotas. La cantidad máxima de cuotas permitidas es de ${this.convertirNumeroATexto(this.maxCuotasModulosTexto)} (${this.maxCuotasModulosTexto}), siempre que el monto de la cuota mínima sea superior al valor equivalente de diez (10) módulos.`
                }
            ];
        },
        selectedPlan() {
            return this.buttons.find(btn => btn.value === this.tipoPP) || null;
        },
        calculaMontoTotal() {
            const cuotas = Number(this.simularPP.cancuotas) || 0
            const cuotaInicialNum = Number(this.cuotaUno) || 0
            const cuotaPosteriorNum = Number(this.cuotasFrances) || 0
            if (!cuotas || !cuotaInicialNum || !cuotaPosteriorNum) return ''
            const total = cuotaInicialNum + (cuotas - 1) * cuotaPosteriorNum
            return (this.tipoPP == 10) ? this.formatMoney(total) : this.formatFloat(total)
        },
        cuotaInicial() {
            if (this.tipoPP == 10) {
                return this.formatMoney(this.cuotaUno);
            } else {
                return this.formatFloat(this.cuotaUno);
            }
        },

        cuotasPosteriores() {
            if (this.tipoPP == 10) {
                return this.formatMoney(this.cuotasFrances);
            } else {
                return this.formatFloat(this.cuotasFrances);
            }
        }
    },
    watch: {
        'tipoPP'(newValue) {
            if (newValue == 10) {
                this.simularPP.tipoPago = 1; // Asignar tipo de interés por defecto
                this.simularPP.TipoPago = 1; // Asignar tipo de interés por defecto
                this.simularPP.mpr_tipinteres = 1; // Asignar tipo de interés por defecto
                this.simularPP.tipo = 10; // Asignar TipoPago por defecto
                this.simularPP.totamorti = this.deudaPlanPagoTotales.totalPesos;
            } else {
                this.simularPP.TipoPago = 2; // Asignar tipo de interés por defecto
                this.simularPP.tipo = 20; // Asignar TipoPago por defecto
                this.simularPP.tipoPago = 20; // Asignar tipo de interés por defecto
                this.simularPP.mpr_tipinteres = 2; // Asignar tipo de interés por defecto
                this.simularPP.totamorti = this.deudaPlanPagoTotales.totalModulos;
            }
            this.simularPP.numero_calculo = this.deudaPlanPagoTotales.numero_calculo;
            this.simularPP.totalff = this.deudaPlanPagoTotales.totalff;
            this.simularPP.totalsf = this.deudaPlanPagoTotales.totalsf;
            this.simularPP.anticipo = 0
            this.simularPP.totalAportes = this.deudaPlanPagoTotales.totalAportes;
            this.simularPP.totalAportesModulos = this.deudaPlanPagoTotales.totalAportesModulos;
            this.simularPP.valmod = this.deudaPlanPagoTotales.valmod;
            this.simularPP.gastos = this.deudaPlanPagoTotales.gastos; // Asignar TipoPago por defecto
            this.simularPP.nroafi = this.nroafi; // Asignar TipoPago por defecto
            this.simularPP.tipdebito = 1; // Asignar TipoPago por defecto
            this.simularPP.email = this.emailAfi; // Asignar TipoPago por defecto
        },
        'simularPP.mpr_tipinteres'(nuevo) {
            if (nuevo == 1) {
                this.simularPP.totamorti = this.deudaPlanPagoTotales.totalPesos;

            } else {
                this.simularPP.totamorti = this.deudaPlanPagoTotales.totalModulos;
            }
            this.simularPP.totalff = this.deudaPlanPagoTotales.totalff;
            this.simularPP.totalsf = this.deudaPlanPagoTotales.totalsf;
            this.simularPP.anticipo = 0
            this.simularPP.totalAportes = this.deudaPlanPagoTotales.totalAportes;
            this.simularPP.totalAportesModulos = this.deudaPlanPagoTotales.totalAportesModulos;
            this.simularPP.valmod = this.deudaPlanPagoTotales.valmod;
            this.simularPP.gastos = this.deudaPlanPagoTotales.gastos; // Asignar TipoPago por defecto
        }
    }
};
</script>

<style scoped>
.custom-card-actions-ha {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    padding: 0 16px;
    z-index: 5;
}

.custom-content-padding {
    padding-bottom: 0px !important;
}
</style>